declare var dataLayer;
export class RegisterGoogleTag {
    public static register(body:any){
        dataLayer.push(body);
    }
}
